import React from 'react';
import styled from 'styled-components/macro';
import useTranslations from '../../../hooks/useTranslations';
import InputBase from '../../form/InputBase';
import { DatePicker } from '@material-ui/pickers';
import moment from '../../../utils/momentWithLocale';
import Select from '../../engine/SelectEngine';
import getUTCNoonForDate from '../../../utils/getUTCNoonForDate';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  ${({ $wideConditionValueContainer }) =>
    $wideConditionValueContainer &&
    `div[class^='MuiCollapse-container'] {flex: 1;}
        span[class*='AlignmentSpan'] {flex: 1;}
    `}
`;

const PrefixText = styled.span`
  margin-right: 0.8rem;
  margin-left: ${({ $hierarchyLvl = 0 }) => $hierarchyLvl * 0.8}rem;
`;

const InfixText = styled.span`
  margin: 0 0.8rem;
`;

const DateContainer = styled.div`
  display: inline-block;
  vertical-align: middle;
  width: 10em;
`;

const SectionDiv = styled.div`
  position: relative;
`;

const wideConditionValueContainerVariantList = {
  'form-builder': true
};

const DateRangeQueryBuilderView = props => {
  const t = useTranslations();
  return (
    <Container
      $wideConditionValueContainer={
        wideConditionValueContainerVariantList[props.variant]
      }
    >
      <SectionDiv>
        <PrefixText>{t('logic.when')}</PrefixText>
        <Select
          variant={props.variant}
          data-testid="condition-builder-datetype-select"
          value={props.dateType}
          placeholder={props.dateType || 'Select'}
          onChange={props.setDateType}
          options={[
            { text: 'logic.last_updated', value: 'updated' },
            { text: 'logic.last_status_change', value: 'status' },
            { text: 'logic.last_submitted', value: 'submission' }
          ]}
        />
        <div>
          <InfixText>{t('logic.is_between')}</InfixText>
          <DateContainer>
            <DatePicker
              autoOk
              TextFieldComponent={InputBase}
              variant={props.variant}
              inputVariant={props.variant}
              format={moment.localeData().longDateFormat('L')}
              value={props.value ? props.parseDate(props.value) : null}
              emptyLabel="Select date"
              maxDate={props.maxStartDateString}
              onChange={dateValue => {
                const chosenDate = dateValue
                  ? getUTCNoonForDate(dateValue)
                  : null;
                props.updateVal(chosenDate, 0);
              }}
            />
          </DateContainer>
          <InfixText>and</InfixText>
          <DateContainer>
            <DatePicker
              autoOk
              TextFieldComponent={InputBase}
              variant={props.variant}
              inputVariant={props.variant}
              format={moment.localeData().longDateFormat('L')}
              value={props.value2 ? props.parseDate(props.value2) : null}
              emptyLabel="Select date"
              minDate={props.minEndDateString}
              onChange={dateValue => {
                const chosenDate = dateValue
                  ? getUTCNoonForDate(dateValue)
                  : null;
                props.updateVal(chosenDate, 1);
              }}
            />
          </DateContainer>
        </div>
      </SectionDiv>
    </Container>
  );
};

export default DateRangeQueryBuilderView;
